const STORAGE_KEY = {
  campaignApplicantList: 'campaignApplicantList',
  influencerList: 'influencerList',
  campaignListBusiness: 'campaignListBusiness',
  appliedCampaignList: 'appliedCampaignList',
  campaignListInfluence: 'campaignListInfluence',
}

const ROLE = {
  Business: 'business',
  Influencer: 'influencer',
}

const APPLICANT_STATUS = {
  Pending: 'pending',
  Invited: 'invited',
  Matched: 'matched',
}

const APPLY_STATUS = {
  Default: 'default',
  Pending: 'pending',
  Applied: 'applied',
  Matched: 'matched',
}

const getFilteredData = (param, data, keyword) => {
  return data.filter(option => {
    return (
      option[`${param}`]
        .toString()
        .toLowerCase()
        .indexOf(keyword.toLowerCase()) >= 0
    )
  })
}

export {
  STORAGE_KEY,
  ROLE,
  APPLICANT_STATUS,
  APPLY_STATUS,
  getFilteredData,
}